import PropTypes from "prop-types";
// form
import { Controller, useFormContext } from "react-hook-form";
// @mui
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import dayjs from "dayjs";

// ----------------------------------------------------------------------

RHFTimeField.propTypes = {
  name: PropTypes.string,
  max_value: PropTypes.string,
  helperText: PropTypes.node,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  date: PropTypes.string,
  disableBeforeCurrentTime: PropTypes.bool, // New prop to conditionally disable times
};

export default function RHFTimeField({
  disabled = false,
  label,
  name,
  max_value,
  date,
  size = "small",
  helperText,
  disableBeforeCurrentTime = false, // Default to false if not provided
  ...other
}) {
  const { control } = useFormContext();

  const currentDateTime = dayjs();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const [hours, minutes, seconds] = field.value?.split(":") || [
          "",
          "",
          "",
        ];

        return (
          <TimePicker
            disabled={disabled}
            {...field}
            value={
              field?.value &&
              dayjs().set({ hour: hours, minute: minutes, second: seconds })._d
            }
            onChange={(v) => field.onChange(dayjs(v, "HH:mm").format("HH:mm"))}
            minTime={
              disableBeforeCurrentTime ? currentDateTime.toDate() : undefined
            } // Conditionally set minTime
            slotProps={{
              textField: {
                helperText: error?.message || helperText,
                size,
              },
            }}
            label={<span>{label}</span>}
            viewRenderers={{
              hours: renderTimeViewClock,
              minutes: renderTimeViewClock,
              seconds: renderTimeViewClock,
            }}
            {...other}
          />
        );
      }}
    />
  );
}
